<template>
    <div v-if="webInfo">
        <div class="elementTitle">{{webInfo.WidgetTeacher.part1.elementTitle}}</div>
        <div class="elementLabel">{{webInfo.WidgetTeacher.part1.elementLabel}}</div>
        <div class="teacherInfo">
            <div class="teacherInfoDetails">
                <el-image class="teacherInfoPic" lazy style="display: block;" :src="globalConfig.filePath + webInfo.WidgetTeacher.part1.teacherInfoPic" fit="cover"></el-image>
                <div class="teacherInfoContent">
                    <p v-for="(item, index) in webInfo.WidgetTeacher.part1.teacherInfoContent" :key="index">{{item}}</p>
                </div>
            </div>
            <div class="teacherInfoTips">
                <div v-for="(item, index) in webInfo.WidgetTeacher.part1.teacherInfoTips" :key="index">
                    <img :src="globalConfig.filePath + item.src">
                    <span>{{item.label}}</span>
                </div>
            </div>
        </div>

        <div class="elementTitle">{{webInfo.WidgetTeacher.part2.elementTitle}}</div>
        <div class="elementLabel">{{webInfo.WidgetTeacher.part2.elementLabel}}</div>
        <div class="teacherListDiv" style="margin-bottom: 50px;">
            <el-row :gutter="10" style="margin-top: 15px">
                <el-col :span="4" v-for="(item, index) in webInfo.WidgetTeacher.part2.teacherPicListA" :key="index">
                    <el-image lazy style="height: calc(80vw * 1.56 / 6);min-height: 255px;width: 100%;display: block;" :src="globalConfig.filePath + item.src" fit="cover"></el-image>
                </el-col>
            </el-row>
        </div>

        <div class="elementTitle">{{webInfo.WidgetTeacher.part3.elementTitle}}</div>
        <div class="elementLabel">{{webInfo.WidgetTeacher.part3.elementLabel}}</div>
        <div class="teacherListDiv">
            <el-row :gutter="10" style="margin-top: 15px">
                <el-col :span="4" v-for="(item, index) in webInfo.WidgetTeacher.part3.teacherPicListB" :key="index">
                    <el-image lazy style="height: calc(80vw * 1.56 / 6);min-height: 255px;width: 100%;display: block;" :src="globalConfig.filePath + item.src" fit="cover"></el-image>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                webInfo: null,
            };
        },
        updated() {},
        mounted() {
            var that = this;
            that.webInfo = that.$parent.webInfo;
        },
        methods: {},
    };
</script>

<style scoped>
    .elementTitle {
        font-size: 32px;
        font-weight: bold;
        line-height: 60px;
        width: 100%;
        text-align: center;
    }

    .elementLabel {
        font-size: 16px;
        line-height: 30px;
        width: 100%;
        text-align: center;
    }

    .teacherInfoDetails {
        display: flex;
        justify-content: space-between;
        width: 100%;
        margin: 0 auto;
        overflow: hidden;
        margin-top: 50px;
    }

    .teacherInfo,
    .teacherListDiv {
        width: 65%;
        margin: 0 auto;
    }

    .teacherInfo >>> img,
    .teacherListDiv >>> img {
        transition: 0.3s;
    }

    .teacherInfo >>> img:hover,
    .teacherListDiv >>> img:hover {
        transform: scale(1.1);
    }

    .teacherInfoPic {
        height: 370px;
        min-width: 660px;
        width: 660px;
        margin-right: 30px;
    }

    .teacherInfoContent {
        height: 330px;
        overflow: auto;
        font-size: 14px;
        line-height: 25px;
        width: 100%;
        margin: 20px 0;
    }

    .teacherInfoContent p {
        margin-bottom: 10px;
    }

    .teacherInfoTips {
        display: flex;
        justify-content: space-around;
        margin: 50px auto;
    }

    .teacherInfoTips div {
        background-color: #236de9;
        color: #fff;
        height: 40px;
        line-height: 40px;
        padding: 0 10px;
        width: 15%;
        text-align: center;
        position: relative;
    }

    .teacherInfoTips div::before {
        content: '';
        width: 50px;
        height: 50px;
        border: 4px solid #236de9;
        background-color: #fff;
        box-sizing: border-box;
        transform: rotate(45deg);
        display: block;
        position: absolute;
        left: -25px;
        top: -5px;
        z-index: 1;
    }

    .teacherInfoTips div img {
        width: 25px;
        height: 25px;
        position: absolute;
        left: -12.5px;
        top: 5px;
        z-index: 2;
    }
</style>


// WEBPACK FOOTER //
// src/components/Widget/WidgetTeacher.vue